<div class="tooltip-list scroll--accent"
    [ngClass]="[ customClass != null ? customClass : '']">
    <ng-template #simpleText>
        {{text}}
    </ng-template>
    <ng-container *ngTemplateOutlet="contentTemplate || simpleText">
    </ng-container>
    <ng-template dynamicComponentHost></ng-template>
</div>